import NavigationController from "./controller/NavigationController"

export default NavigationController;